// Internal Imports
import { camelCaseKeysDeep } from '../../utils/dataUtils.js';
import { authenticatedRequest } from './authenticatedRequest.js';

// Local Functions
const fetchCurrentUser = ({ locale }) =>
  authenticatedRequest({
    path: `v1.2.0/${locale}/users/me`,
    verb: 'GET',
  }).then((response) => camelCaseKeysDeep(response.data.user));

// Module Exports
export { fetchCurrentUser };
